import React from 'react'
import SupplyBillPriceOne from './SupplyBillPriceOne'

const SupplyBillPriceGeneral = ({ priceAgree }) => {
  return (
    <>
        {
            priceAgree ?
                <div className='agreePrice'>
                    <SupplyBillPriceOne
                        value={priceAgree.agree}
                        currency={priceAgree.currency}
                        type={'agree'}
                        title='Погоджено'
                    />
                    <SupplyBillPriceOne
                        value={priceAgree.disagree}
                        currency={priceAgree.currency}
                        type={'disagree'}
                        title='Не погоджено'
                    />
                    <SupplyBillPriceOne
                        value={priceAgree.wait}
                        currency={priceAgree.currency}
                        type={'wait'}
                        title='Очікує погодження'
                    />
                </div>
            : ''
        }
    </>
  )
}

export default SupplyBillPriceGeneral